<div class="footer">
  <div class="wrap">

    <div class="link">
      <h2 class="sr-only">하단메뉴영역</h2>
      <ul>
        <li><a href="http://www.harfko.com/" target="_blank"><img src="/assets/images/e_harfko.png" alt="harfko" /></a></li>
      </ul>
    </div>

    <div class="company">
      <h2 class="sr-only">회사 정보</h2>
      <div class="logo-area">
	      <div class="fl">
	        <a routerLink="/main" class="footer-logo">
	          <img src="/assets/images/e_footer_logo.png" alt="logo" />
	        </a>
	      </div>
	      <div class="sns fr">
	        <a href="https://www.facebook.com/hvacr.kraia" target="_blank">
	          <img src="/assets/images/facebook.png" alt="facebook" />
	        </a>
	        <a href="https://twitter.com/kraiasns" target="_blank">
	          <img src="/assets/images/twitter.png" alt="twitter" />
	        </a>
	      </div>
      </div>
      <div class="cb"></div>
      <div class="address">
        622 Bongeunsaro, Samseong-dong, Gangnam-gu, Seoul 135-881 Korea<br/>
        Tel : 0082-2-2193-4324<span></span>Fax : 0082-2-369-7515<span></span>Email : yhk@ref.or.kr<span></span>http://www.ref.or.kr<span></span>http://www.harfko.com

      </div>
    </div>

    <div class="copyright">Copyright ⓒ 2019 KRAIA.or.kr. All Rights Reserved.</div>
  </div>
</div>
